var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 2H10.75V3.25H9.5V5.75H8.25V4.5H5.75V5.75H4.5V8.25H5.75V9.5H3.25V10.75H2V13.25H3.25V14.5H5.75V15.75H4.5V18.25H5.75V19.5H8.25V18.25H9.5V20.75H10.75V22H13.25V20.75H14.5V18.25H15.75V19.5H18.25V18.25H19.5V15.75H18.25V14.5H20.75V13.25H22V10.75H20.75V9.5H18.25V8.25H19.5V5.75H18.25V4.5H15.75V5.75H14.5V3.25H13.25V2ZM13.25 3.25V5.75H14.5V7H15.75V5.75H18.25V8.25H17V9.5H18.25V10.75H20.75V13.25H18.25V14.5H17V15.75H18.25V18.25H15.75V17H14.5V18.25H13.25V20.75H10.75V18.25H9.5V17H8.25V18.25H5.75V15.75H7V14.5H5.75V13.25H3.25V10.75H5.75V9.5H7V8.25H5.75V5.75H8.25V7H9.5V5.75H10.75V3.25H13.25ZM10.75 8.25H13.25V9.5H10.75V8.25ZM9.5 10.75V9.5H10.75V10.75H9.5ZM9.5 13.25H8.25V10.75H9.5V13.25ZM10.75 14.5H9.5V13.25H10.75V14.5ZM13.25 14.5V15.75H10.75V14.5H13.25ZM14.5 13.25V14.5H13.25V13.25H14.5ZM14.5 10.75H15.75V13.25H14.5V10.75ZM14.5 10.75V9.5H13.25V10.75H14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsM);
export default __webpack_public_path__ + "static/media/settings-m.7de79098e18032d667a9b3fa92cc5cbe.svg";
export { ForwardRef as ReactComponent };